import { type Location } from '@opentripplanner/types';
import type { Bounds, BasePosition } from '#/types/Location';

export const isOutsideBounds = (
  { lat, lon }: Location,
  bounds: Bounds
): boolean => {
  const { top, bottom, left, right } = bounds;
  return lat > top || lat < bottom || lon < left || lon > right;
};

/**
 * Convert a geolocation object into the format used for locations within this
 * application.
 */
export const positionToLocation = (
  position: BasePosition,
  label: string | null = null
): Location | null =>
  position
    ? {
        lat: position.coords.latitude,
        lon: position.coords.longitude,
        name: label ?? undefined,
      }
    : null;

/**
 * Convert an object in the format used for locations within this app into a
 * JavaScript object that mirrors the structure and properties of a
 * GeolocationPosition object
 */
export const locationToPosition = (
  location: Location | null
): BasePosition | null =>
  location
    ? {
        coords: {
          latitude: location.lat,
          longitude: location.lon,
        },
      }
    : null;
